"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/List/MeetingsFilter.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Form = require('web/components/Form');
var _MenuPicker = require('web/components/VideoRooms/Room/MenuPicker');

var _DesktopMeetingsFilterTooltip = require('./DesktopMeetingsFilterTooltip'); var _DesktopMeetingsFilterTooltip2 = _interopRequireDefault(_DesktopMeetingsFilterTooltip);









const MeetingsFilter = ({
  filterMenuOptions,
  currentFilter,
  searchQuery,
  onFilterUpdate,
  onSearchQueryUpdate,
}) => {
  const [isMobileFilterMenuOpen, setIsMobileFilterMenuOpen] = _react.useState.call(void 0, false)
  const [isDesktopFilterMenuOpen, setIsDesktopFilterMenuOpen] = _react.useState.call(void 0, false)
  // Kept in state, as in the class: the tooltip re-renders with its target
  // once the toggle mounts. The state setter is the (stable) callback ref.
  const [filterToggleRef, setFilterToggleRef] = _react.useState(null)

  // The tooltip calls back with (inputId, value); the class dropped the id.
  const handleDesktopFilterUpdate = _react.useCallback.call(void 0, 
    (_, f) => onFilterUpdate(f),
    [onFilterUpdate],
  )

  const openMobileFilterMenu = _react.useCallback.call(void 0, () => setIsMobileFilterMenuOpen(true), [])
  const closeMobileFilterMenu = _react.useCallback.call(void 0, () => setIsMobileFilterMenuOpen(false), [])

  const openDesktopFilterMenu = _react.useCallback.call(void 0, () => setIsDesktopFilterMenuOpen(true), [])
  const closeDesktopFilterMenu = _react.useCallback.call(void 0, () => setIsDesktopFilterMenuOpen(false), [])

  const desktopFilterToggleClassName = _classBuilder2.default.call(void 0, 
    "blmh-mobile-hide meeting-rooms--list--filter-toggle-icon",
    { active: isDesktopFilterMenuOpen },
  )

  return (
    _react2.default.createElement('div', { className: "meeting-rooms--list--filter", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
      , _react2.default.createElement('div', { className: "meeting-rooms--list--filter-input-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        , _react2.default.createElement(_Form.TextInput, {
          value: searchQuery,
          onChange: e => onSearchQueryUpdate(e.target.value),
          placeholder: "Search for meetings..."  ,
          className: "meeting-rooms--list--filter-input", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
        )
        , _react2.default.createElement('div', { className: "meeting-rooms--list--filter-search-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}} )
        , _react2.default.createElement('div', {
          onClick: openMobileFilterMenu,
          className: "blmh-desktop-hide meeting-rooms--list--filter-toggle-icon" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
        )
        , _react2.default.createElement('div', {
          ref: setFilterToggleRef,
          onClick: openDesktopFilterMenu,
          className: desktopFilterToggleClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
        )
      )
      /* The JS also passed inputId="currentFilter", which MenuSelect never read. */
      , _react2.default.createElement(_MenuPicker.MenuSelect, {
        title: "View...",
        isOpen: isMobileFilterMenuOpen,
        onClose: closeMobileFilterMenu,
        options: filterMenuOptions,
        onChange: onFilterUpdate,
        value: currentFilter, __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
      )
      , _react2.default.createElement(_DesktopMeetingsFilterTooltip2.default, {
        isOpen: isDesktopFilterMenuOpen,
        onClose: closeDesktopFilterMenu,
        domTarget: filterToggleRef,
        inputId: "currentFilter",
        onChange: handleDesktopFilterUpdate,
        options: filterMenuOptions,
        activeOption: currentFilter, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
      )
    )
  )
}

exports. default = MeetingsFilter
